import initStore from './index'
// import projects from './modules/projects'

export default initStore(/* {
  projects,
} */)
